<template>
  <ElCard class="hot-act">
    <div class="title"><span class="item-icon"></span>热门活动</div>
    <a class="act-content" :href="article.url" target="_blank">
      <div class="content-text">
        <p class="act-title">{{ article.title }}</p>
        <p class="act-content">
          {{ article.content }}
        </p>
      </div>
      <div class="content-img">
        <img :src="article.img" />
      </div>
    </a>
  </ElCard>
</template>

<script>
export default {
  name: 'HotAct',
  data() {
    return {
      article: {}
    };
  },
  async mounted() {
    await this._timeInterval();
  },
  methods: {
    async _timeInterval() {
      await this._getData();
      setTimeout(() => {
        this._timeInterval();
      }, 60000 * 5);
    },

    async _getData() {
      const res = await this.$http.post('/api/home/index/popularActivity');
      if (res && res.length) {
        /* eslint-disable */
        this.article = res[0];
      }
    }
  }
};
</script>

<style lang="scss">
.hot-act {
  margin-left: 8px;
  .el-card__body {
    padding: 10px 15px;
    height: 220px;
    box-sizing: border-box;
    .title {
      font-size: 16px;
      border-bottom: 1px dashed #ededed;
      padding-bottom: 10px;
      margin-bottom: 5px;
      .item-icon {
        width: 12px;
        height: 12px;
        margin-bottom: 2px;
        margin-right: 10px;
        display: inline-block;
        border-radius: 100%;
        background-color: #4b90ff;
        vertical-align: middle;
      }
    }
    .act-content {
      font-size: 14px;
      display: flex;
      text-decoration: none;
      .content-text {
        line-height: 1.9;
        margin-right: 18px;
        padding: 15px 10px;
        width: 100px;
        flex-grow: 1;
        .act-title {
          color: #4c90ff;
          margin: 0;
        }
        .act-content {
          margin: 0;
          color: #b1b1b1;
        }
      }
      .content-img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 140px;
        height: 140px;
        img {
          max-width: 100%;
        }
      }
      &:hover .content-text {
        border-radius: 8px;
        background-color: #ececec;
      }
    }
  }
}
</style>
